import React from "react";

const SDCSubmission = (props) => {
  const civilDesignElements = () => {
    if (props.civilDesign === undefined || props.civilDesign.length === 0) {
      return;
    } else {
      return (
        <>
          <h4 className="card-title">Civil Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.civilDesign.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </p>
        </>
      );
    }
  };

  const otherCivil = () => {
    if (props.otherCivil) {
      return (
        <>
          <h4 className="card-title">Other Civil Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.otherCivil === "" ? (
              <></>
            ) : (
              <>{<li>{props.otherCivil}</li>}</>
            )}
          </p>
        </>
      );
    } else {
      return;
    }
  };

  const mechDesignElements = () => {
    if (props.mechDesign === undefined || props.mechDesign.length === 0) {
      return;
    } else {
      return (
        <>
          <h4 className="card-title">Mechanical Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.mechDesign.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </p>
        </>
      );
    }
  };

  const otherMech = () => {
    if (props.otherMech) {
      return (
        <>
          <h4 className="card-title">Other Mechanical Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.otherMech === "" ? <></> : <>{<li>{props.otherMech}</li>}</>}
          </p>
        </>
      );
    } else {
      return;
    }
  };

  const elecDesignElements = () => {
    if (props.elecDesign === undefined || props.elecDesign.length === 0) {
      return;
    } else {
      return (
        <>
          <h4 className="card-title">Electrical Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.elecDesign.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </p>
        </>
      );
    }
  };

  const otherElec = () => {
    if (props.otherElec) {
      return (
        <>
          <h4 className="card-title">Other Electrical Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.otherElec === "" ? <></> : <>{<li>{props.otherElec}</li>}</>}
          </p>
        </>
      );
    } else {
      return;
    }
  };

  const packageDesignElements = () => {
    if (props.packageDesign === undefined || props.packageDesign.length === 0) {
      return;
    } else {
      return (
        <>
          <h4 className="card-title">Package Plant Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.packageDesign.map((x) =>
              x === "Other" ? <></> : <li key={x}>{x}</li>
            )}
          </p>
        </>
      );
    }
  };

  const otherPackage = () => {
    if (props.otherPackage) {
      return (
        <>
          <h4 className="card-title">Other Package Plant Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.otherPackage === "" ? (
              <></>
            ) : (
              <>{<li>{props.otherPackage}</li>}</>
            )}
          </p>
        </>
      );
    } else {
      return;
    }
  };

  const undergroundPipelineElements = () => {
    if (
      props.undergroundPipeline === undefined ||
      props.undergroundPipeline.length === 0
    ) {
      return;
    } else {
      return (
        <>
          <h4 className="card-title">Underground Pipeline Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.undergroundPipeline.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </p>
        </>
      );
    }
  };

  const otherUndergroundPipeline = () => {
    if (props.otherUndergroundPipeline) {
      return (
        <>
          <h4 className="card-title">Underground Pipeline Capabilities:</h4>
          <p className="card-text" style={{ marginLeft: 20 }}>
            {props.otherUndergroundPipeline === "" ? (
              <></>
            ) : (
              <>{<li>{props.otherUndergroundPipeline}</li>}</>
            )}
          </p>
        </>
      );
    } else {
      return;
    }
  };

  const logo = `/logos/${props.companyLogo.replace(/ /g, "")}`;

  return (
    <>
      <div className="row d-flex justify-content-center" key={props.id}>
        <div className="col-md-8">
          <div className="card" style={{ borderRadius: 10 }}>
            <div className="card-body">
              <div className="container" style={{ margin: "0" }}>
                <div className="row d-flex ">
                  <div className="col-3" style={{ padding: 0 }}>
                    {props.companyLogo.includes("---") ? (
                      <></>
                    ) : (
                      <img
                        src={logo} //make this look at the logo import possibly props.companyLogo
                        alt={props.companyName + "logo"}
                        style={{
                          objectFit: "contain",
                          maxWidth: "100%",
                          height: "auto",
                        }}
                      />
                    )}
                  </div>
                  <div className="col-9 align-self-center">
                    <h4 className="lead" style={{ fontSize: 22 }}>
                      {props.companyName}
                    </h4>
                  </div>
                </div>
              </div>
              <br />
              {civilDesignElements()}
              {otherCivil()}
              {mechDesignElements()}
              {otherMech()}
              {elecDesignElements()}
              {otherElec()}
              {undergroundPipelineElements()}
              {otherUndergroundPipeline()}
              {packageDesignElements()}
              {otherPackage()}
              <h4>Submission supported by: {props.supportedBy}</h4>
              <h4>Date of last design review: {props.dateOfLastReview}</h4>
            </div>

            <hr
              style={{
                color: "#6d7a80",
                backgroundColor: "#6d7a80",
                height: 2,
                borderColor: "#6d7a80",
              }}
            ></hr>
            <div className="justify-content-center">
              <div
                className="container"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <table
                  className="table-lg table-responsive"
                  id="contact-details"
                >
                  <tbody>
                    <tr id="row1">
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                        id="keyContact"
                      >
                        Key Contact:
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        {props.name}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        Phone Number:
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        {props.companyPhone}
                      </td>
                    </tr>
                    <tr id="row2">
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        Company Address:
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        {props.companyAddress}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        E-mail Address:
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          alignItems: "center",
                        }}
                      >
                        {props.companyEmail}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SDCSubmission;
